import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { MyDatePicker } from "./my-date-picker.component";
import { InputFocusDirective } from "./directives/my-date-picker.input.directive";

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [MyDatePicker, InputFocusDirective],
    exports: [MyDatePicker, InputFocusDirective]
})
export class MyDatePickerModule {
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/mydatepicker/src/my-date-picker/my-date-picker.module.ts